"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.panoramaClient = exports.createPanoramaClient = void 0;
const panorama_client_web_1 = require("@wix/panorama-client-web");
const config_1 = require("./config");
const createPanoramaClient = () => {
    return (0, panorama_client_web_1.panoramaClientFactory)({
        baseParams: config_1.baseParams,
    })
        .withGlobalConfig(config_1.globalConfig)
        .client();
};
exports.createPanoramaClient = createPanoramaClient;
exports.panoramaClient = (0, exports.createPanoramaClient)();
//# sourceMappingURL=panoramaClient.js.map